import { render } from "./data-hud.vue?vue&type=template&id=63d8bb35&scoped=true"
import script from "./data-hud.vue?vue&type=script&lang=js"
export * from "./data-hud.vue?vue&type=script&lang=js"

import "./data-hud.vue?vue&type=style&index=0&id=63d8bb35&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d8bb35"]])

export default __exports__